import { Box, Flex, HStack, Image, Select, Text, VStack } from '@chakra-ui/react';
import cartP from 'assets/cartP.png';
import { deleteIcon } from 'pages/dashboard/components/Icons';
import WalletHistoryPrice from 'components/Wallet/WalletHistoryPrice';

const StoreCartItem = ({ item, deleteFromCart }) => {
    const quantity = item?.qty;

    return (
        <Box w={{ base: '85vw', lg: 'full' }} mx="auto" mt="15px">
            <HStack w="full" justifyContent="space-between" alignItems="start" mb=".5rem" mt="20px">
                <Box w="70%">
                    <Text fontSize="15px" fontWeight={600}>
                        {item.name}
                    </Text>
                    <Text color="#868E96" fontSize="11px">
                        {item.brandName}
                    </Text>
                </Box>
                <Box textAlign="right">
                    <Text color="#868E96" fontSize="12px" textDecoration="line-through">
                        {item.discount && '₦' + item.discount}
                    </Text>
                    <Text fontSize="18px" fontWeight={600}>
                        {item.price && <WalletHistoryPrice price={item.price * quantity} />}
                    </Text>
                </Box>
            </HStack>
            <HStack w="full" justifyContent="space-between">
                <Image src={cartP} w="120px" ml="1rem" />
                <VStack gap="20px">
                    {item.color && (
                        <HStack gap="20px" alignItems="center" justifyContent="space-between">
                            <Text>Color</Text>
                            <Select
                                placeholder={item.color}
                                size="md"
                                fontSize="13px"
                                w="100px"
                                h="36px"
                                textTransform="capitalize"
                            />
                        </HStack>
                    )}
                    {item.size && (
                        <HStack gap="20px" alignItems="center" justifyContent="space-between">
                            <Text>Size</Text>
                            <Select
                                placeholder={item.size}
                                size="md"
                                h="36px"
                                fontSize="13px"
                                w="100px"
                                textTransform="capitalize"
                            />
                        </HStack>
                    )}
                    <HStack gap="20px" alignItems="center" justifyContent="space-between">
                        <Text>Qty</Text>
                        <Text>{item.qty}</Text>
                    </HStack>
                    <Flex gap="20px" justifyContent="flex-end" w="full">
                        <Box cursor="pointer" onClick={() => deleteFromCart(item)}>
                            {deleteIcon}
                        </Box>
                    </Flex>
                </VStack>
            </HStack>
        </Box>
    );
};

export default StoreCartItem;
